/* IT HIPPIE — pile « Craquez aussi pour… » du panier (1 article).
   Rendu : snippets/cart-swipe-upsell.liquid.
   - Glisser la carte du dessus (ou ✕) : elle passe sous la pile.
   - Toucher une taille : ajout au panier, puis re-rendu du tiroir (même méthode que ith-quick-add).
   - La jauge du haut montre en pointillé où elle arriverait avec la carte du dessus.
   Tout est en délégation : le tiroir remplace son HTML après chaque ajout. */
(function () {
  if (window.__cswBound) return;
  window.__cswBound = true;

  var SWIPE_MIN = 70;  // px pour valider un glissement
  var TAP_MOVE = 8;    // px max pour un tap

  function cards(stack) {
    return Array.prototype.slice.call(stack.querySelectorAll('[data-csw-card]'));
  }

  function layout(stack) {
    cards(stack).forEach(function (c, i) {
      c.style.setProperty('--pos', Math.min(i, 3));
      c.setAttribute('data-pos', i > 2 ? 'far' : String(i));
      c.classList.toggle('is-top', i === 0);
      c.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
      c.querySelectorAll('a, button').forEach(function (el) {
        if (i === 0) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
      });
    });
    ghost(stack);
  }

  function ghost(stack) {
    var drawer = stack.closest('cart-drawer') || document;
    var track = drawer.querySelector('.cpb__track');
    if (!track) return;
    var g = track.querySelector('.cpb__ghost');
    if (!g) {
      g = document.createElement('div');
      g.className = 'cpb__ghost';
      track.insertBefore(g, track.firstChild);
    }
    var top = stack.querySelector('[data-csw-card]');
    g.style.width = top ? (parseFloat(top.getAttribute('data-fill')) || 0) + '%' : '0';
  }

  function next(stack, dir) {
    var list = cards(stack);
    if (list.length < 2) return;
    var top = list[0];
    top.classList.remove('is-dragging');
    top.style.transform = 'translate(' + (dir < 0 ? '-' : '') + '130%, 10px) rotate(' + (dir * 14) + 'deg)';
    top.classList.add('is-out');
    setTimeout(function () {
      top.style.transform = '';
      top.classList.remove('is-out');
      stack.appendChild(top);
      layout(stack);
    }, 300);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-csw-stack]:not([data-csw-ready])').forEach(function (stack) {
      stack.setAttribute('data-csw-ready', '1');
      layout(stack);
    });
  }

  /* ---------- Ajout au panier ---------- */
  function refreshDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return Promise.resolve();
    var wrap = cd.closest('[id^="shopify-section-"]');
    if (!wrap) return Promise.resolve();
    var sid = wrap.id.replace('shopify-section-', '');
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid))
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (!json || !json[sid]) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = json[sid];
        var fresh = tmp.querySelector('cart-drawer');
        if (fresh) cd.innerHTML = fresh.innerHTML;
      });
  }

  function updateCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, .cart-counter').forEach(function (el) {
        el.textContent = c.item_count;
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
    }).catch(function () {});
  }

  function add(btn) {
    if (btn.classList.contains('is-loading')) return;
    var id = btn.getAttribute('data-csw-add');
    if (!id) return;
    btn.classList.add('is-loading');
    document.documentElement.classList.add('cpb-smooth-add');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      return refreshDrawer();
    }).then(function () {
      updateCount();
    }).catch(function () {
      btn.classList.remove('is-loading');
    }).then(function () {
      setTimeout(function () { document.documentElement.classList.remove('cpb-smooth-add'); }, 400);
    });
  }

  /* ---------- Glissement + taps (pointer events : le verrou de scroll iOS du
     tiroir supprime parfois le clic synthétique, on gère donc le tap nous-mêmes) ---------- */
  var drag = null;
  var ignoreClickUntil = 0;

  document.addEventListener('pointerdown', function (e) {
    var card = e.target.closest && e.target.closest('.csw__card.is-top');
    if (!card || (e.pointerType === 'mouse' && e.button !== 0)) return;
    drag = { card: card, stack: card.parentNode, x: e.clientX, y: e.clientY, dx: 0, moved: false, axis: null, target: e.target };
  }, { passive: true });

  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    if (!drag.axis && (Math.abs(dx) > TAP_MOVE || Math.abs(dy) > TAP_MOVE)) {
      drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    }
    if (drag.axis !== 'x') return;
    drag.moved = true;
    drag.dx = dx;
    drag.card.classList.add('is-dragging');
    drag.card.style.transform = 'translate(' + dx + 'px, 0) rotate(' + (dx / 18) + 'deg)';
  }, { passive: true });

  function endDrag(e) {
    if (!drag) return;
    var d = drag;
    drag = null;
    d.card.classList.remove('is-dragging');
    if (d.moved) {
      ignoreClickUntil = Date.now() + 400;
      if (Math.abs(d.dx) > SWIPE_MIN) {
        next(d.stack, d.dx < 0 ? -1 : 1);
      } else {
        d.card.style.transform = '';
      }
      return;
    }
    if (e.type !== 'pointerup' || d.axis === 'y') return;
    var btn = d.target.closest && d.target.closest('[data-csw-add]');
    if (btn) {
      ignoreClickUntil = Date.now() + 600;
      add(btn);
    }
  }
  document.addEventListener('pointerup', endDrag, { passive: true });
  document.addEventListener('pointercancel', endDrag, { passive: true });

  document.addEventListener('click', function (e) {
    var inCard = e.target.closest && e.target.closest('.csw__card');
    if (inCard && Date.now() < ignoreClickUntil) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    var addBtn = e.target.closest && e.target.closest('[data-csw-add]');
    if (addBtn) { e.preventDefault(); add(addBtn); return; }
    var pass = e.target.closest && e.target.closest('[data-csw-pass]');
    if (pass) {
      var stack = pass.closest('[data-csw]').querySelector('[data-csw-stack]');
      if (stack) next(stack, -1);
    }
  }, true);

  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('.csw__card')) e.preventDefault();
  });

  /* ---------- (Ré)initialisation après chaque re-rendu du tiroir ---------- */
  function watch() {
    init(document);
    new MutationObserver(function () { init(document); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
